import { h } from 'preact'
import { Highlight, connectRefinementList } from 'react-instantsearch-dom'
import Phrase from '../../../libs/translationsUtils/phrase'

type Hit = {
  label: string,
  value: string,
  count:number,
  isRefined: boolean
}

interface Props {
  title: string,
  items: Array<Hit>,
  isFromSearch: boolean,
  refine: (val: string) => void,
  searchForItems: (val: string) => void,
  createURL: (val: string) => string
}

const List = ({
  title,
  items,
  isFromSearch,
  refine,
  createURL
}: Props) => {
  return <div className='instant-search-tags-filter'>
    <h4>{title}</h4>
    {!items.length
      ? <div class='instant-search__filter-no-results'><Phrase p='No results' m='Control' /></div>
      : (
        <ul className='public-tags list list--float'>
          {items.map(item => (
            <li key={item.label}>
              <a
                className={`tag--pill qa-tag-pill ${item.isRefined ? 'tag--active' : ''}`}
                href={createURL(item.value)}
                onClick={event => {
                  event.preventDefault()
                  refine(item.value)
                }}
              >
                {isFromSearch ? (
                  <Highlight attribute='label' hit={item}/>
                ) : (
                  item.label
                )}{' '}
                ({item.count})
              </a>
            </li>
          ))}
        </ul>
      )
    }
  </div>
}

export default connectRefinementList(List)
